import React from 'react';
import SEOWrapper from '../../SEOWrapper/SEOWrapper';
import { PlayerPortalsPageProps } from './types';
import { PlayerPortalsPageTemplate } from '../../templates';
import { PlayerPortalsPageSubHeader } from './PlayerPortalsPageSubHeader';
import { PlayerPortalsBodyContent } from './PlayerPortalsPageBodyContent';
import { PlayerPortalsPagePreFooter } from './PlayerPortalsPagePreFooter';

import styles from './PlayerPortalsPage.module.scss';

const PageContent = ({
  seo,
  children,
}: Pick<PlayerPortalsPageProps, 'seo' | 'children'>) => {
  return (
    <main data-testid={'page'} className={styles.wrapper}>
      <SEOWrapper
        title={seo?.title}
        description={seo?.description}
        keywords={seo?.keywords}
        noindex={seo?.noindex}
        nofollow={seo?.nofollow}
        urlSlug={seo?.urlSlug}
      />
      {children}
    </main>
  );
};

export const PlayerPortalsPage = ({
  seo,
  pageTemplate,
  body,
  sidebar,
  subheader,
  preFooter,
}: PlayerPortalsPageProps) => {
  if (pageTemplate) {
    return (
      <PlayerPortalsPageTemplate
        header={pageTemplate.header}
        footer={pageTemplate.footer}
      >
        <PageContent seo={seo}>
          <PlayerPortalsPageSubHeader subheader={subheader} />
          <PlayerPortalsBodyContent body={body} sidebar={sidebar} />
          <PlayerPortalsPagePreFooter preFooter={preFooter} />
        </PageContent>
      </PlayerPortalsPageTemplate>
    );
  }

  return (
    <PageContent seo={seo}>
      <PlayerPortalsPageSubHeader subheader={subheader} />
      <PlayerPortalsBodyContent body={body} sidebar={sidebar} />
      <PlayerPortalsPagePreFooter preFooter={preFooter} />
    </PageContent>
  );
};
